/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { selectLanguage } from "../Redux/actions";
import {
  convertToRGBAString,
  orderByPosition,
  renderSmile,
} from "utils/helperFunctions";
import { fontSize, smileySizes } from "utils/CONSTANTS";
import LogoSection from "./header/LogoSection";
import { appParamater } from "utils/appDesign";

const DefaultOption = ({ properties, onClick, languages }) => {
  return (
    <Space
      direction="vertical"
      style={{
        width: "100%",
      }}
      className="gap"
    >
      {orderByPosition(languages).map((item, index) => (
        <div
          key={index}
          onClick={onClick(item)}
          className="lang-items-block lang-holder pointer"
          style={{
            justifyContent:
              properties.show_flags && properties.show_labels
                ? "space-between"
                : "center",
            backgroundColor: convertToRGBAString(
              properties.language_label_bg_color
            ),
            border: `2px solid ${convertToRGBAString(
              properties.language_label_border_color
            )}`,
          }}
        >
          {properties.show_labels && (
            <span
              className="font-helvetica-neue-medium"
              style={{
                color: convertToRGBAString(properties.language_label_color),
                fontSize: fontSize[properties.language_label_size],
                fontWeight: properties.language_label_style.includes("b")
                  ? "bold"
                  : "normal",
                textDecoration: properties.language_label_style.includes("u")
                  ? "underline"
                  : "",
                fontStyle: properties.language_label_style.includes("i")
                  ? "italic"
                  : "normal",
              }}
            >
              {item.label}
            </span>
          )}
          {properties.show_flags && (
            <div className="lang-image">
              <img
                alt=""
                style={{
                  width: 40,
                  height: 40,
                }}
                src={item.flag_url}
              />
            </div>
          )}
        </div>
      ))}
    </Space>
  );
};

const ZlcOption = ({ properties, onClick, languages }) => {
  const blockRef = useRef();
  const [design, setDesign] = useState({
    labels: [],
    options: [],
  });
  const [optionSize, setOptionSize] = useState(0);

  const generate = () => {
    const labels = [];
    const options = [];
    orderByPosition(languages).forEach((lang, index) => {
      labels.push(
        <span
          key={index}
          style={{
            color: convertToRGBAString(properties.language_label_color),
            fontSize: fontSize[properties.language_label_size],
          }}
        >
          {lang.label}
        </span>
      );

      options.push(
        <div className="zlc_lang_options_wrapper" key={index}>
          <div
            style={{
              width: optionSize,
              height: optionSize,
              borderColor: convertToRGBAString(
                properties.language_label_border_color
              ),
              color: convertToRGBAString(properties.title_color),
              fontSize: fontSize["L"],
            }}
            className="zlc_lang_options"
            onClick={onClick(lang)}
          >
            <span>{lang.title}</span>
          </div>
        </div>
      );
    });

    return { labels, options };
  };

  useEffect(() => {
    const { labels, options } = generate();
    setDesign({
      labels,
      options,
    });
  }, [optionSize]);

  useEffect(() => {
    if (blockRef.current !== null) {
      const optionCount = languages.length;
      const blockWidth = blockRef.current.offsetWidth - (optionCount - 1) * 10;
      const optionWidth = blockWidth / optionCount;
      const staticWidth = window.innerWidth > 768 ? 150 : 100;
      setOptionSize(optionWidth > staticWidth ? staticWidth : optionWidth);
    }
  }, [blockRef.current]);

  return (
    <Row className="zlc_lang_container">
      <Col span={24}>
        <div
          className="zlc_lang_label_block"
          style={{
            background: convertToRGBAString(
              properties.language_label_border_color
            ),
          }}
        >
          {design.labels}
        </div>
      </Col>
      <Col span={24}>
        <div className="zlc_lang_options_block" ref={blockRef}>
          {design.options}
        </div>
      </Col>
    </Row>
  );
};

const LanguageScreen = ({ page }) => {
  const { widgetJSON = {} } = useSelector((state) => state);
  const { data = {} } = widgetJSON;
  const {
    general_settings: { company },
  } = data;

  const dispatch = useDispatch();
  const [titles, setTitles] = useState([]);
  const [counter, setCounter] = useState(0);
  const [elementsHeigth, setElementsHeigth] = useState({
    block: "",
    smile: "",
    text: "",
  });

  const { properties, languages } = page || {};
  const { page_bg } = properties || {};
  let interval;

  useEffect(() => {
    const newTitles = [];
    page.languages.map((item) => {
      newTitles.push(item.title);
    });
    setTitles(newTitles);

    interval = setInterval(() => {
      setCounter((counter) => counter + 1);
    }, 2000);

    if (page_bg) {
      const metas = document.getElementsByTagName("meta");
      for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute("name") === "theme-color") {
          document.head.removeChild(metas[i]);
        }
      }
      const themeColorMetaElement = document.createElement("meta");
      themeColorMetaElement.name = "theme-color";
      themeColorMetaElement.content = convertToRGBAString(page_bg);
      document.head.appendChild(themeColorMetaElement);
      document.documentElement.style.setProperty(
        "--page-header-color",
        convertToRGBAString(page_bg)
      );
    }

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (counter > titles.length - 1) {
      setCounter(0);
    }
    // eslint-disable-next-line
  }, [counter]);

  const onLanguageSelect = (language) => () => {
    const { lang_code: lang, ltr } = language;
    dispatch(selectLanguage({ lang, ltr }));
  };

  const logo = true;

  const props = { properties, onClick: onLanguageSelect, languages };
  const isShowLogo = properties.show_logo
  return (
    <Row
      style={{
        flexGrow: 1,
      }}
      align="center"
      justify="center"
    >
      <Col
        xs={24}
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundImage: `url(${properties.background_image_url})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat, repeat",
          boxShadow: `inset 2000px 0 0 0 ${convertToRGBAString([
            ...properties.dimmer_color.slice(0, -1),
            properties.dimmer_opacity,
          ])}`,
        }}
      >
        {logo && isShowLogo && <LogoSection />}

        <div
          style={{
            flexGrow: logo ? null : 1,
            marginTop: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex:!isShowLogo ? 1:"unset" 
          }}
        >
          <div>
            <div className="lang-content-block">
              <div className="lang-smile-block">
                {properties.show_smile && (
                  <div className="lang-smile">
                    <div
                      style={{
                        width: smileySizes[properties.smiley_size || "S"],
                        height: smileySizes[properties.smiley_size || "S"],
                        fontSize: smileySizes[properties.smiley_size || "S"],
                        color: convertToRGBAString(properties.smiley_color),
                        // marginBottom: 25,
                      }}
                    >
                      {renderSmile("excellent")}
                    </div>
                  </div>
                )}
                <div className="lang-smile-text">
                  {properties?.show_animation && (
                    <span
                      className="font-helvetica-neue-medium"
                      style={{
                        color: convertToRGBAString(properties.title_color),
                        fontSize: fontSize[properties.animated_title_size],
                        minHeight: fontSize[properties.animated_title_size],
                        textAlign: "center",
                      }}
                    >
                      {titles[counter]}
                    </span>
                  )}
                </div>
              </div>

              {appParamater.name === "zlc" ? (
                <ZlcOption {...props} />
              ) : (
                <DefaultOption {...props} />
              )}
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default LanguageScreen;
